<div class="acc-open-engagements-view-part">
	<common-engagement-grid [pageService]="pageService" [data]="engagements()"></common-engagement-grid>
</div>